import React from 'react'
import ContentLoader from 'react-content-loader'

export const QuantitySelectorLoader: React.FC = () => {
  return (
    <ContentLoader viewBox="0 0 380 70" speed={2} backgroundColor="#f3f3f3" foregroundColor="#999">
      <rect x="29" y="6" rx="0" ry="0" width="1" height="0" />
      <rect x="6" y="9" rx="0" ry="0" width="252" height="23" />
      <rect x="6" y="46" rx="0" ry="0" width="357" height="20" />
    </ContentLoader>
  )
}
